var React = require('react');

function Spa (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.59234 7.95079C12.0795 7.95079 13.6327 6.76478 13.6327 5.42557C13.6327 4.08636 11.2248 3.25 8.73766 3.25C6.25055 3.25 5.15664 4.59465 5.15664 5.93387C5.15664 7.27308 7.10524 7.95079 9.59234 7.95079ZM16.7018 9.50482C16.7018 10.9666 14.3508 12.2108 10.2622 12.1379C6.17356 12.065 3.66942 10.9529 3.66942 9.49106C3.66942 8.73855 4.4516 8.12615 5.70737 7.70902C7.2225 9.03863 11.4571 9.31057 13.4384 7.17385C14.5262 7.40695 16.7018 8.04302 16.7018 9.50482ZM18.3335 14.4001C18.3647 16.1891 14.8357 17.526 10.065 17.6093C5.29426 17.6926 1.8224 16.6145 1.66699 14.4001C1.82245 12.7295 3.41531 12.1855 4.50306 11.836C6.17363 12.8071 12.273 13.7785 15.886 12.1856C17.3318 12.787 18.3181 13.5221 18.3335 14.4001Z","fill":"#616466"}));
}

Spa.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = Spa;

Spa.default = Spa;
